import {
  readStoredItem,
  writeStoredItem,
  SESSION_SCOPE,
} from 'src/utils/storageManager';
import { useEffect } from 'react';
import { useAuth } from 'src/hooks/useAuth';
import { reportError } from 'src/modules/logs/Sentry';
import { updateUserTimezone } from 'src/queries/user';

const TZ_SYNCED_KEY = 'tz_synced';

export const useSyncTimezone = () => {
  const { isLoggedIn } = useAuth();

  useEffect(() => {
    if (!isLoggedIn || readStoredItem(TZ_SYNCED_KEY, SESSION_SCOPE)) return;

    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (tz) {
      writeStoredItem(TZ_SYNCED_KEY, '1', SESSION_SCOPE);
      updateUserTimezone(tz).catch(err => {
        reportError('Failed to sync user timezone', err);
      });
    }
  }, [isLoggedIn]);
};
